export const APP_ID = import.meta.env.VITE_EVENT_TEAM_APP_ID
export const APP_URL = import.meta.env.VITE_EVENT_TEAM_APP_URL
export const APP_HOME_PAGE = 'companies'
